import { useState } from 'react';

interface GiftProps {
  isUnlocked: boolean;
}

export default function Gift({ isUnlocked }: GiftProps) {
  const [showClaim, setShowClaim] = useState(false);
  const [claimed, setClaimed] = useState(false);

  const handleClaim = () => {
    setShowClaim(true);
  };

  const handleConfirmClaim = () => {
    setClaimed(true);
    setTimeout(() => {
      setShowClaim(false);
    }, 3000);
  };

  return (
    <section id="gift" className="py-24 px-4 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Получить Награду
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {isUnlocked 
              ? 'Твоя награда готова! Забери свои 50 000 бьютисов' 
              : 'Пройди опрос, чтобы разблокировать награду'}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className={`relative rounded-3xl p-12 text-center transition-all duration-500 ${
            isUnlocked 
              ? 'bg-gradient-to-br from-amber-400 via-orange-400 to-amber-500 shadow-2xl' 
              : 'bg-gray-100'
          }`}>
            {!isUnlocked && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-900/50 rounded-3xl backdrop-blur-sm">
                <div className="text-center">
                  <i className="ri-lock-fill text-7xl text-white mb-4"></i>
                  <p className="text-white text-xl font-semibold">Заблокировано</p>
                  <p className="text-white/80 mt-2">Пройди опрос, чтобы разблокировать</p>
                </div>
              </div>
            )}

            <div className="relative z-10">
              <div className="mb-8">
                <i className={`ri-coin-fill text-8xl ${isUnlocked ? 'text-white animate-pulse' : 'text-gray-400'}`}></i>
              </div>

              <h3 className={`text-5xl font-bold mb-4 ${isUnlocked ? 'text-white' : 'text-gray-400'}`}>
                50 000 бьютисов
              </h3>

              <p className={`text-xl mb-8 ${isUnlocked ? 'text-white/90' : 'text-gray-500'}`}>
                Получи бонусные бьютисы за участие в опросе!
              </p>

              {isUnlocked && !claimed && (
                <button
                  onClick={handleClaim}
                  className="bg-white text-orange-600 px-12 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Забрать Награду
                </button>
              )}

              {claimed && (
                <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6">
                  <i className="ri-checkbox-circle-fill text-5xl text-white mb-3"></i>
                  <p className="text-white text-xl font-semibold">
                    Награда получена! 🎁
                  </p>
                  <p className="text-white/80 mt-2">
                    50 000 бьютисов добавлены в твой аккаунт
                  </p>
                </div>
              )}
            </div>
          </div>

          {isUnlocked && (
            <div className="mt-12 grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-2xl p-6 text-center shadow-md">
                <i className="ri-gift-2-line text-4xl text-orange-600 mb-3"></i>
                <h4 className="font-bold text-gray-800 mb-2">Бесплатно</h4>
                <p className="text-sm text-gray-600">Никаких скрытых условий</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-md">
                <i className="ri-time-line text-4xl text-orange-600 mb-3"></i>
                <h4 className="font-bold text-gray-800 mb-2">Мгновенно</h4>
                <p className="text-sm text-gray-600">Получи награду сразу</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center shadow-md">
                <i className="ri-shield-check-line text-4xl text-orange-600 mb-3"></i>
                <h4 className="font-bold text-gray-800 mb-2">Безопасно</h4>
                <p className="text-sm text-gray-600">100% защищённая транзакция</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Claim Modal */}
      {showClaim && !claimed && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-3xl p-8 max-w-md w-full animate-bounce-in">
            <div className="text-center">
              <i className="ri-gift-line text-6xl text-orange-500 mb-4"></i>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Подтверди получение награды
              </h3>
              <p className="text-gray-600 mb-8">
                Нажми кнопку ниже, чтобы получить свои 50 000 бьютисов
              </p>
              
              <div className="flex gap-4">
                <button
                  onClick={() => setShowClaim(false)}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-full font-semibold hover:bg-gray-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Отмена
                </button>
                <button
                  onClick={handleConfirmClaim}
                  className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white py-3 rounded-full font-semibold hover:from-amber-600 hover:to-orange-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  Получить
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
